<template>
  <div id="app">
    <flexible />
    <dfHeader />
    <transition name="router-fade" mode="out-in">
      <router-view class="app" />
    </transition>
  </div>
</template>

<script>
  import dfHeader from "@/components/dfHeader.vue";
  import flexible from "@/components/flexible-ui/index.vue";
  import { orderSource } from './utils/env'

  export default {
    name: 'App',
    components: {
      flexible,
      dfHeader
    },
    data () {
      return {
        redirect_url: ""
      }
    },
    created () {
      this.getToken()
    },
    methods: {
      getToken () {
        let token = "";
        if( this.$route.query.redirect_uri ){
          this.redirect_url = this.$route.query.redirect_uri;
          if( this.$route.query.redirect_uri.indexOf("?")>0 ){
            this.redirect_url = this.$route.query.redirect_uri.split("?")[0];
            if( this.$route.query.redirect_uri.indexOf("token=")>0 ){
              token = decodeURIComponent((this.$route.query.redirect_uri.split("?")[1]).split('token=')[1]);
            }
          }
        }
        if( this.$route.query.token ){
          token = decodeURIComponent(this.$route.query.token || "");
        }
        if( token ){
          localStorage.setItem("token", token);
          // alert(localStorage.getItem("token"))
          if( this.$route.path=='/login' ){
            this.$router.replace({ path: this.redirect_url ? this.redirect_url : '/index' });
          }
        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  @import "assets/init.scss";
  #app{
    padding-top: 110px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue